import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const SelectClientContainer = styled.div`
  margin: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 152px;

  & > div {
    display: flex;
    flex-direction: column;
    width: 356px;
    gap: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: start;
  }

  & > div > h3 {
    font-weight: 600;
    font-size: 14px;
    line-height: 180%;
    margin: 0;
    color: ${colors.text['main-900']};
  }

  & > div > p {
    font-weight: 400;
    font-size: 12px;
    line-height: 180%;
    color: ${colors.text['sub-500']};
    text-align: center;
  }

  @media (min-width: 769px) {
    padding-top: 66px;
  }

  @media (max-width: 400px) {
    padding-top: 232px;
  }
`;
